import { APP_LOCALE, APP_TIMEZONE } from "@/constants";
import { Temporal } from "@js-temporal/polyfill";

export function formatDatetime(
  instant: string | null,
  options: Intl.DateTimeFormatOptions = {
    dateStyle: "medium",
    timeStyle: "short",
  },
): string {
  if (instant === null) {
    return "";
  }

  return Temporal.Instant.from(instant)
    .toZonedDateTimeISO(APP_TIMEZONE)
    .toLocaleString(APP_LOCALE, options);
}
